import { Fragment } from 'react'

import { SectionHero } from './sections/hero'
import { SectionAdvantages } from './sections/advantages'
import { SectionFaq } from './sections/faq'
import { SectionHowTo } from './sections/howTo'
import { SectionCTA } from './sections/cta'

const LandingPage = () => (
  <Fragment>
    <SectionHero />
    <SectionAdvantages />
    <SectionHowTo />
    <SectionCTA />
    <SectionFaq />
  </Fragment>
)

export default LandingPage
